import { Pagination } from "../types/PaginiationResult";
import { RoyaltyParameters } from "../types/Royalties/RoyaltyParameters";
import { RoyaltyOrderItem } from "../types/Royalties/RoyaltyOrderItem";
import { RoyaltyOrderItemSummary } from "../types/Royalties/RoyaltyOrderItemSummary";
import { DateTime } from "luxon";
import { AxiosInstance } from "axios";

export default class RoyaltiesService {
  private _endpoint = "Royalty";
  private _client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this._client = client;
  }

  public async listRoyalties({
    page,
    from,
    to,
    layer,
  }: RoyaltyParameters): Promise<Pagination<RoyaltyOrderItemSummary>> {
    return this._client
      .get<any>(`${this._endpoint}`, {
        params: {
          page,
          from: from.toISO()!.split("T")[0],
          to: to.toISO()!.split("T")[0],
          layer,
        },
      })
      .then((response) => {
        return response.data;
      });
  }

  public async getRoyaltyOrderItem(
    orderItemId: string,
  ): Promise<RoyaltyOrderItem> {
    return this._client
      .get<any>(`${this._endpoint}/${orderItemId}`)
      .then((response) => {
        return response.data;
      });
  }

  public async getMultiLayerReport(
    from: DateTime,
    to: DateTime,
    layers: string[],
  ): Promise<{ data: Blob; filename: string }> {
    return this._client
      .get<Blob>(`${this._endpoint}/MultiLayerReport`, {
        params: {
          from: from.toISO()!.split("T")[0],
          to: to.toISO()!.split("T")[0],
          layers,
        },
        paramsSerializer: (params) => {
          const searchParams = new URLSearchParams();
          searchParams.append("from", params.from);
          searchParams.append("to", params.to);
          for (const layer of params.layers) {
            searchParams.append("layers", layer);
          }
          return searchParams.toString();
        },
      })
      .then((response) => {
        let filename = "report.csv";
        var disposition = response.headers["content-disposition"];
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }
        return { data: response.data, filename };
      });
  }

  public async getReport(
    from: DateTime,
    to: DateTime,
    layer: string,
  ): Promise<{ data: Blob; filename: string }> {
    return this._client
      .get<Blob>(`${this._endpoint}/Report`, {
        params: {
          from: from.toISO()!.split("T")[0],
          to: to.toISO()!.split("T")[0],
          layer,
        },
      })
      .then((response) => {
        let filename = "report.csv";
        var disposition = response.headers["content-disposition"];
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }

        return {
          data: response.data,
          filename: filename,
        };
      });
  }
}
